module.exports = __webpack_public_path__ + "img/icono_4.a7ae97ad.svg";